import React from 'react';
import { Send } from 'lucide-react';

/**
 * Text input + send button for the AI Concierge chat.
 */
export const ChatInput = React.forwardRef(({ value, onChange, onSend, disabled, placeholder }, ref) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSend();
    }
  };

  return (
    <div className="border-t border-border p-3 flex gap-2 shrink-0">
      <input
        ref={ref}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        className="flex-1 px-3 py-2.5 bg-transparent border border-border text-sm focus:outline-none focus:border-foreground/40 transition-colors"
        disabled={disabled}
        data-testid="chat-input"
      />
      <button
        onClick={onSend}
        disabled={disabled || !value.trim()}
        className="px-3 py-2.5 bg-foreground text-background disabled:opacity-40 hover:opacity-90 transition-opacity"
        data-testid="chat-send-btn"
      >
        <Send className="w-4 h-4" />
      </button>
    </div>
  );
});

ChatInput.displayName = 'ChatInput';

export default ChatInput;
